var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSafety(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-safety-4879444 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.08 8.23163C17.1856 8.33744 17.2449 8.48083 17.2449 8.63032C17.2449 8.77981 17.1856 8.92319 17.08 9.02901L12.4208 13.6874C12.3151 13.793 12.1717 13.8524 12.0222 13.8524C11.8727 13.8524 11.7293 13.793 11.6236 13.6874L9.26896 11.3327C9.16411 11.2268 9.10546 11.0837 9.10584 10.9347C9.10622 10.7857 9.16561 10.6429 9.271 10.5376C9.3764 10.4322 9.51923 10.3729 9.66823 10.3726C9.81724 10.3723 9.9603 10.4311 10.0661 10.536L12.023 12.4927L16.2827 8.23163C16.335 8.17918 16.3971 8.13756 16.4655 8.10917C16.5339 8.08078 16.6073 8.06616 16.6813 8.06616C16.7554 8.06616 16.8288 8.08078 16.8972 8.10917C16.9656 8.13756 17.0277 8.17918 17.08 8.23163ZM20.5702 5.62298L12.309 2L4.04207 5.62481C4.00823 7.54054 3.92091 12.5516 4.17649 13.5285C5.03148 16.7946 7.75192 19.6453 12.2626 22C17.0917 19.4853 19.8432 16.4963 20.4429 13.1136C20.6719 11.8192 20.6315 8.43372 20.5702 5.62298Z",
    fill: "#565555"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafety);
export default __webpack_public_path__ + "static/media/safety.c7d4182f1be4dfbc8adbfd6118862e34.svg";
export { ForwardRef as ReactComponent };